module.exports = __webpack_public_path__ + "static/img/t-2.c4693bd7.png";